<template>
  <div class="identityAuth">
    <header-item
      :title-array="titleArray"
      :is-show="headShow"
      :title-mb="titleArray[0]"
    />
    <div class="formClass">
      <van-form v-if="bindInfo.isBind" class="findTwo">
        <van-field
          v-model="bindInfo.realName"
          style="border-radius:16px 16px  0 0 "
          readonly
          label="您的姓名"
        />
        <van-field
          v-model="bindInfo.idCard"
          readonly
          label="身份证号码"
        />
        <van-field
          readonly
          label="防沉迷状态"
        >
          <template #input>
            <p :style="bindInfo.adultText== '已成年'?'color:#40BC40':'color:red'">{{ bindInfo.adultText }}</p>
          </template>
        </van-field>
      </van-form>
      <van-form v-else class="findTwo" @submit="onSubmitAuth">
        <van-field
          v-model="bindInfo.phone"
          readonly
          label="手机号"
        />
        <van-field
          v-model="formParams.code"
          style="border-radius:  0 0  16px 16px"
          maxlength="6"
          label="短信验证码"
          :rules="rules.codeRules"
        >
          <template v-if="!bindInfo.isBind" #button>
            <p v-if="!showTime" style="color: #616edf; cursor: pointer" @click="getCode">{{ timeMsg }}</p>
            <p v-else style="color: #878787; cursor: pointer">{{ codeTime }} S</p>
          </template>
        </van-field>
        <p style="padding: 0.2rem 0.4rem;width:7rem;color: #878787">
          *如果一分钟内没有收到验证码请重新获取
        </p>
        <van-field
          v-model="formParams.realName"
          style="border-radius:   16px 16px 0 0 "
          label="姓名"
          :rules="rules.nameRules"
        />
        <van-field
          v-model="formParams.idCard"
          style="border-radius:  0 0  16px 16px"
          label="身份证号"
          :rules="rules.idRules"
        />
        <van-checkbox v-model="checked" class="checkbox">我已阅读并同意
          <span style="color: #626fdd" @click.stop="ltUserRule">《雷霆游戏用户隐私政策》</span>
          <span style="color: #626fdd" @click.stop="ltGameRule">《雷霆游戏用户协议》</span>
        </van-checkbox>
        <div class="bottom">
          <van-button
            round
            block
            type="info"
            native-type="submit"
            color="#616edf"
            class="formClass_btn"
          >确 定</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>
<script>
import headerItem from '@/views/accountCenter/common/header'
import * as api from '@/api/account-center-manage/identityAuth'
import sendCode from '@/mixins/sendCode'
import rules from '@/mixins/validator'
import { ltCaptcha } from '@/utils/ltCaptcha'
export default {
  name: 'IdentityAuth',
  components: {
    headerItem
  },
  mixins: [sendCode],
  props: {
    headShow: {
      type: Boolean,
      default: () => true
    }
  },
  data() {
    return {
      isAuth: false,
      titleArray: ['身份认证', '首页', '账号管理中心', '身份认证'],
      username: '',
      checked: false,
      rules: rules,
      formParams: {},
      bindInfo: {},
      currentIndex: 0
    }
  },
  created() {},
  mounted() {
    if (this.$isFlag) {
      document.querySelector('.identityAuth').className = ['identityAuth identityAuthH5 accountCommonH5']
    } else {
      document.querySelector('.identityAuth').className = ['identityAuth identityAuthWeb accountCommonWeb']
    }
    this.check_bind()
  },
  methods: {
    getCode() {
      ltCaptcha((captcha) => {
        this.$tool.sendCode({
          type: 'BIND_ID_CARD',
          captcha
        }).then(res => {
          if (res.status == 0) {
            this.startTimer()
            this.$msg('短信发送成功', 'success')
          }
        })
      })
    },
    check_bind() {
      api.check_bind().then(res => {
        if (res.status == 0) {
          this.bindInfo = res.data
          if (!this.bindInfo.isBind && !this.bindInfo.isBindPhone) {
            this.$pubConfirm('请先完成绑定手机号', () => {
              this.$router.push('/accountCenter/accountList/bindPhoneNum')
            })
            return
          }
          if (this.bindInfo.adult) {
            this.bindInfo.adultText = '已成年'
          } else {
            this.bindInfo.adultText = '未成年'
          }
        }
      })
    },
    ltGameRule() {
      window.open('https://www.leiting.com/terrace/news/news_detail_ff8080816f6510d4016f9e532924003e.html')
    },
    ltUserRule() {
      window.open('https://www.leiting.com/terrace/news/news_detail_ff80808171a5bad00171a64e53870006.html')
    },
    onSubmitAuth() {
      if (!this.checked) {
        this.$msg('请阅读并同意协议')
        return
      }
      api.bind(this.formParams).then(res => {
        if (res.status == 0) {
          this.$msg(res.message, 'success')
          this.$ssd.track('leiting_accountmanage_realNameSuccess')
        } else {
          this.$ssd.track('leiting_accountmanage_realNameFail')
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~assets/css/accountCommon.styl';

// h5
  .identityAuthH5 {
    font-size: 0.25rem;
    background: #f5f7fa;
    .checkbox {
      margin: 0.3rem 0;
      position: relative;
    }
    #ltCaptchaLogin {
      display: flex;
      justify-content: center;
    }
    #ltCaptchaLogin #SM_BTN_1,
    #ltCaptchaLogin #sm-btn-bg {
      width: 100% !important;
      height: 0.86rem !important;
      line-height: 0.86rem !important;
    }
    .captcha {
      margin: 0.2rem;
    }
    .captcha .sm-btn-wrapper .sm-btn {
      width: 100% !important;
    }
    .formClass {
      padding: 0.4rem;
      .findTwo {
        .formClass_btn {
          margin: 0.5rem 0;
        }
        span {
          font-size: 0.26rem;
        }
      }
    }
  }
// web
  .identityAuthWeb {
    padding-bottom: .5rem;
    border-radius: 10px;
    background: #fff;
    font-size: 0.25rem;
    .checkbox {
      margin: 0.3rem 0;
      font-size: 0.28rem;
    }
    #ltCaptchaLogin {
      margin: 0.5rem 0;
    }
    #ltCaptchaLogin #SM_BTN_1,
    #ltCaptchaLogin #sm-btn-bg {
      width: 100% !important;
      height: 0.86rem !important;
      line-height: 0.86rem !important;
    }
    .formClass {
      margin: auto;
      // width: 40%;
    }
    .findTwo {

    display: flex;
    flex-direction: column;
    align-items: center;

      ::v-deep .van-cell {
        font-size: 0.28rem;
        width: 8rem;
      }
      .bottom {
        p {
          margin: 0.2rem;
        }
        .formClass_btn {
          margin: 0.5rem auto;
          width: 7.4rem;
        }
      }
    }
    .findThree {
      display: flex;
      justify-content: center;
      flex-direction: column;
      img {
        width: 6.34rem;
        margin: auto;
      }
      p {
        color: #606de2;
        font-size: 0.32rem;
        margin: 0.32rem 0;
      }
    }
  }
</style>
